module.exports = __webpack_public_path__ + "resources/message-translate-80731563ae29c3c361e29ca18c367308.svg";